import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "../../app/hooks"
import { ReloadIcon } from "../../images/Icons"
import { loadPartyEventsAsync } from "../partyEvents/partyEventsSlice"
import { sanitizeEmail } from "../../utils/emailUtils"
import { useAuth0 } from "@auth0/auth0-react"

export function ReloadButton() {
    const dispatch = useAppDispatch()
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0()  
      return (
        <div className='iconButtons' onClick={async (e) => {
            e.stopPropagation()
            if (isAuthenticated) {  
                try {
                    const accessToken = await getAccessTokenSilently({ authorizationParams : {
                    }})
                    if (user?.email) {
            dispatch(loadPartyEventsAsync({ 
                email: sanitizeEmail(user?.email),
                token: accessToken
             }))
            }
        } catch (error)  {
        }
             }
        }}><ReloadIcon/></div>
    )
}